import { values } from '../_helpers'

const _enum = {
  light: 0,
  mediumMinus: 1,
  medium: 2,
  mediumPlus: 3,
  pronounced: 4
}

const aromaFlavourIntensity = { ..._enum, name: 'aromaFlavourIntensity', values: values(_enum) }

export {
  aromaFlavourIntensity
}
